import { combineReducers } from 'redux';

import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes';

/* State shape
{
    loadingState: {
        isLoading: bool,
        success: bool,
        error: Array
    },
    leadersState: {
        players: Array,
        goalies: Array
    }
}
 */

const playersLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_PLAYERS)(actionTypes.PLAYERS_RESPONSE);
const goaliesLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_GOALIES)(actionTypes.GOALIES_RESPONSE);

const playersReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.PLAYERS_RESPONSE:
            if (!state[action.payload.gameType]) {
                state[action.payload.gameType] = action.payload.players
            }
            return state;
        default: return state;
    }
};

const goaliesReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.GOALIES_RESPONSE:
            if (!state[action.payload.gameType]) {
                state[action.payload.gameType] = action.payload.players
            }
            return state;
        default: return state;
    }
};

const pointsLeadersReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.POINTS_LEADERS:
            if (!state[action.payload.gameType]) {
                state[action.payload.gameType] = action.payload.pointsLeaders
            }
            return state;

        default: return state;
    }
};

const goalsLeadersReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.GOALS_LEADERS:
            if (!state[action.payload.gameType]) {
                state[action.payload.gameType] = action.payload.goalsLeaders
            }
            return state;

        default: return state;
    }
};

const winsLeadersReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.WINS_LEADERS:
            if (!state[action.payload.gameType]) {
                state[action.payload.gameType] = action.payload.winsLeaders
            }
            return state;

        default: return state;
    }
};

const gaaLeadersReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.GAA_LEADERS:
            if (!state[action.payload.gameType]) {
                state[action.payload.gameType] = action.payload.gaaLeaders
            }
            return state;

        default: return state;
    }
};

const selectedGameTypeReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SET_SELECTED_GAME_TYPE:
            return action.payload.selectedGameType;
        default: return state;
    }
};

const leadersStateReducer = combineReducers({
    allPlayers: playersReducer,
    allGoalies: goaliesReducer,
    pointsLeaders: pointsLeadersReducer,
    goalsLeaders: goalsLeadersReducer,
    winsLeaders: winsLeadersReducer,
    gaaLeaders: gaaLeadersReducer,
    selectedGameType: selectedGameTypeReducer
});

const loadingStateReducer = combineReducers({
    playersLoadingState: playersLoadingStateReducer,
    goaliesLoadingState: goaliesLoadingStateReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    leadersState: leadersStateReducer
});

export default reducer;